module.exports = __webpack_public_path__ + "static/media/ylfraunier.77476953.jpg";